query getSmartRecruitersPost($language: String!, $postingId: String) {
  getSmartRecruitersPost(language: $language, postingId: $postingId) {
    id
    uuid
    name
    applyUrl
    postingUrl
    refNumber
    company {
      identifier
      name
    }
    releasedDate
    location {
      country
      region
      city
      remote
    }
    industry {
      id
      label
    }
    department {
      id
      label
      description
    }
    function {
      id
      label
    }
    typeOfEmployment {
      id
      label
    }
    experienceLevel {
      id
      label
    }
    customField {
      fieldId
      fieldLabel
      valueId
      valueLabel
    }
    ref
    creator {
      name
    }
    jobAd {
      sections {
        companyDescription {
          title
          text
        }
        jobDescription {
          title
          text
        }
        qualifications {
          title
          text
        }
        additionalInformation {
          title
          text
        }
        videos {
          title
          urls
        }
      }
    }
  }
}
